import { types } from 'features/session/store/types'

const initialState = {
  id: null,
  user: {
    displayName: '',
    weeklyWorkingHours: null,
    settingsPreferences: {
      notification: null
    }
  },
  loaded: !localStorage.getItem('id')
}

const sessionReducer = (state = initialState, action) => {
  const payload = action.payload
  switch (action.type) {
    case types.SET_SESSION:
      if (payload.id) {
        localStorage.setItem('id', payload.id)
      }

      return {
        id: payload.id,
        user: payload,
        loaded: true
      }

    case types.SET_USER:
      return {
        ...state,
        user: payload
      }

    case types.SET_WEEKLY_WORKING_HOURS:
      return {
        ...state,
        user: {
          ...state.user,
          weeklyWorkingHours: action.payload
        }
      }

    case types.REMOVE_SESSION:
      localStorage.removeItem('id')
      return {
        ...initialState,
        loaded: true
      }

    default:
      break
  }
  return state
}

export default sessionReducer



// WEBPACK FOOTER //
// ./src/features/session/store/reducer.js